import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  div {
    width: 80%;
    padding: 0 137px;
  }

  content {
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: center;

    h3 {
      font-size: 35px;
      font-family: Poppins;
      color: #3FB4A8;
      padding: 0;
    }
  }

  img {
    width: 900px;
  }
`